import { useState } from 'react'
import { Alert, AlertTitle, Collapse, IconButton } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

const TrackingLimitError = ({title, description}) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(true);

  return (
    <Collapse in={open} sx={{ height: '100%', width: '100%' }}>
        <Alert
          severity="error"
          icon={<ErrorOutlineIcon />}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setOpen(false)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ width: '100%', pl: 5, pr: 5 }}
        >
          <AlertTitle sx={{ fontWeight: '900' }}>{t(title)}</AlertTitle>
          {t(description)}
        </Alert>
    </Collapse>
  )
}

export default TrackingLimitError;